import { useEffect, useState } from 'react'
import { StringParam, useQueryParam, withDefault } from 'use-query-params'

export const useSearchParam = () => {
  const [keyword, setParam] = useQueryParam(
    'keyword',
    withDefault(StringParam, undefined, true)
  )

  const [searchPrivateRequests, setSearchPrivateRequests] = useState(keyword)

  useEffect(() => {
    setSearchPrivateRequests(keyword)
  }, [keyword])

  const setSearchParam: typeof setParam = (value) => {
    setParam(value)
  }

  return {
    searchPrivateRequests,
    keyword,
    setSearchParam,
    setSearchPrivateRequests
  }
}
